module.exports = __webpack_public_path__ + "img/no_notes_icon.3cbbc952.svg";